"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortTableRows = exports.transformDataToGeneralSchema = exports.getTableHeaderData = void 0;
var columnsHelpers_1 = require("./columnsHelpers");
Object.defineProperty(exports, "getTableHeaderData", { enumerable: true, get: function () { return columnsHelpers_1.getTableHeaderData; } });
var dataHelpers_1 = require("./dataHelpers");
Object.defineProperty(exports, "transformDataToGeneralSchema", { enumerable: true, get: function () { return dataHelpers_1.transformDataToGeneralSchema; } });
var sortingRowsHelper_1 = require("./sortingRowsHelper");
Object.defineProperty(exports, "sortTableRows", { enumerable: true, get: function () { return sortingRowsHelper_1.sortTableRows; } });
